import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Badge from "@mui/material/Badge";

export default function Questions({
  setanswerContent,
  questions,
  setquestionItemContent,
  setquestionItemCode,
  activeCode // Received from parent to highlight selected
}) {
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [filteredMessages, setFilteredMessages] = React.useState(questions);

  // Filter Logic
  React.useEffect(() => {
    const filtered =
      questions !== null &&
      questions.filter(
        (message) =>
          message.userName.toLowerCase().includes(searchKeyword.toLowerCase()) ||
          message.question.toLowerCase().includes(searchKeyword.toLowerCase())
      );
    setFilteredMessages(filtered);
  }, [searchKeyword, questions]);

  const handleSelectQuestionItem = (questionCode, question, answer) => {
    setquestionItemCode(questionCode);
    setquestionItemContent(question);
    setanswerContent(answer);
  };

  const colors = {
    primary: "#17082d",
    lightRed: "#ffebee",
    textSecondary: "#757575"
  };

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Search Bar */}
      <Box sx={{ p: 2, borderBottom: "1px solid #f0f0f0" }}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search questions..."
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#9e9e9e" }} />
              </InputAdornment>
            ),
            sx: { borderRadius: "20px", bgcolor: "#f5f5f5", border: "none" },
          }}
          sx={{ "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
        />
      </Box>

      {/* List */}
      <List sx={{ flex: 1, overflowY: "auto", padding: 0 }}>
        {filteredMessages && filteredMessages.length > 0 ? (
          filteredMessages.map(
            ({ questionCode, userName, question, isRead, answer, courseTitle }) => {
              const isSelected = activeCode === questionCode;

              return (
                <React.Fragment key={questionCode}>
                  <ListItemButton
                    onClick={() => handleSelectQuestionItem(questionCode, question, answer)}
                    selected={isSelected}
                    sx={{
                      padding: "15px 20px",
                      borderLeft: isSelected
                        ? `4px solid ${colors.primary}`
                        : "4px solid transparent",
                      bgcolor: isSelected ? colors.lightRed : "transparent",
                      "&.Mui-selected": {
                        bgcolor: colors.lightRed,
                        "&:hover": { bgcolor: "#ffcdd2" },
                      },
                      "&:hover": { bgcolor: "#f9f9f9" },
                    }}
                  >
                    <ListItemAvatar>
                      <Badge
                        color="error"
                        variant="dot"
                        invisible={isRead !== "0"} // Show dot if unread (0)
                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                      >
                        <Avatar
                          alt={userName}
                          src={"/static/images/avatar/1.jpg"} // Replace with dynamic image if available
                          sx={{ bgcolor: isSelected ? colors.primary : "#bdbdbd" }}
                        >
                            {userName.charAt(0)}
                        </Avatar>
                      </Badge>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Box display="flex" justifyContent="space-between">
                          <Typography variant="subtitle2" fontWeight="bold">
                            {userName}
                          </Typography>
                          {/* Optional: Add Date here */}
                        </Box>
                      }
                      secondary={
                        <Box>
                          <Typography variant="caption" display="block" color={colors.primary}>
                            {courseTitle}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            noWrap
                            sx={{ maxWidth: "200px" }}
                          >
                            {question}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItemButton>
                  <Divider component="li" />
                </React.Fragment>
              );
            }
          )
        ) : (
          <Box p={4} textAlign="center" color="text.secondary">
            <Typography>No questions found.</Typography>
          </Box>
        )}
      </List>
    </Box>
  );
}

